import React from 'react'
import { localized } from '@/decorators/localized'
import {
  FileAttachments, defaultChangeHandler
} from '@/components/fileAttachments'
import { Column, DateCell, DateFilterCell, fileDownloadCell } from '@/components/BsrsGrid'
import { InfoLabel } from '@/components/InfoRow'
import { PropertyRenderer } from '@/components/changeRequests/propertyRenderer'

@localized()
class ChangeItemFileAttachments extends React.Component {
  render () {
    const { name, dataSource, downloadAction, localize, simpleView, attachmentsView, ...otherProps } = this.props
    return (
      <div className={attachmentsView && 'attachemnts-inner'}>
        {!attachmentsView && <InfoLabel>{localize('Common.Attachments')}</InfoLabel>}
        <PropertyRenderer name={name} inputType='attachments' dataSource={dataSource} simpleView={simpleView} attachmentsView={attachmentsView} {...otherProps} >
          <Column field='name' title={localize('Common.Name')} />
          <Column field='contentType' title={localize('Common.ContentType')} width='200px' />
          <Column field='length' title={localize('Common.Length')} filter='numeric' width='150px' />
          <Column field='creationTime' title={localize('Common.CreationTime')} filter='date' filterCell={DateFilterCell} cell={DateCell} width='150px' />
          <Column field='id' title={localize('Common.Download')} cell={fileDownloadCell({ downloadAction, localize })} filterable={false} width='110px' />
        </PropertyRenderer>
      </div>
    )
  }
}

class UploadAttachments extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      attachments: []
    }
  }
  onFilesAdded = (e) => {
    if (typeof this.props.onChange === 'function') {
      const currentAttachments = [...this.state.attachments]
      this.props.onChange(currentAttachments)
      this.setState({ attachments: [] })
    }
  }
  onAttachmentChange = (e) => {
    const { attachments } = this.state
    const a = defaultChangeHandler(e, attachments)
    if (a !== attachments) { this.setState({ attachments: a }) }
  }
  render () {
    const { dropzoneFullWidth } = this.props
    return (
      <FileAttachments
        attachments={this.state.attachments}
        onFilesAdded={this.onFilesAdded}
        onChange={this.onAttachmentChange}
        dropzoneFullWidth={dropzoneFullWidth}
      />
    )
  }
}

export {
  ChangeItemFileAttachments,
  UploadAttachments
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/fileAttachments.js